import { motion } from "framer-motion";
import { ArrowUpRight } from "@phosphor-icons/react";
import { SERVICES } from "@/lib/siteData";

export default function Services() {
  return (
    <section id="services" className="relative bg-coal/70 py-24 md:py-36 scanlines" data-testid="services-section">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <span className="font-mono text-xs uppercase tracking-[0.3em] text-brass">/ What We Do</span>
            <h2 className="mt-5 font-display uppercase leading-[0.9] tracking-tighter text-5xl md:text-7xl">
              The Full <span className="text-oxblood">Armory</span>
            </h2>
          </div>
          <p className="max-w-sm font-body text-bone/60 leading-relaxed">
            From your first carry pistol to a full custom build, everything under one roof — done right the first time.
          </p>
        </div>

        <div className="border-t border-l border-steel grid sm:grid-cols-2 lg:grid-cols-3">
          {SERVICES.map((s, i) => (
            <motion.div
              key={s.no}
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.06 }}
              data-testid={`service-${s.no}`}
              className="group relative border-r border-b border-steel p-8 md:p-10 min-h-[280px] flex flex-col justify-between hover:bg-oxblood transition-colors duration-300"
            >
              <div className="flex items-start justify-between">
                <span className="font-display text-2xl text-brass group-hover:text-bone transition-colors duration-300">
                  {s.no}
                </span>
                <ArrowUpRight
                  size={26}
                  className="text-steel group-hover:text-bone group-hover:translate-x-1 group-hover:-translate-y-1 transition-all duration-300"
                />
              </div>
              <div>
                <h3 className="font-display uppercase text-2xl md:text-3xl tracking-tight text-bone leading-none">
                  {s.title}
                </h3>
                <p className="mt-4 font-body text-sm md:text-base text-bone/60 group-hover:text-bone/90 leading-relaxed transition-colors duration-300">
                  {s.desc}
                </p>
              </div>
            </motion.div>
          ))}

          <div className="border-r border-b border-steel p-8 md:p-10 min-h-[280px] flex flex-col sm:flex-row sm:items-center sm:justify-between gap-6 bg-oxblood lg:col-span-3">
            <p className="font-serif italic text-2xl md:text-3xl text-bone leading-snug max-w-xl">
              Don't see what you need? We're a full-service, Class 3 SOT shop — just ask.
            </p>
            <button
              data-testid="services-ask-btn"
              onClick={() => document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" })}
              className="shrink-0 self-start font-mono text-xs uppercase tracking-[0.2em] bg-gold text-ink px-8 py-4 hover:bg-bone transition-colors duration-200"
            >
              Ask The Shop →
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
